import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const Benefits = () => {
  const benefits = [{
    title: 'Ahorrás horas de trabajo.',
    desc: 'Accedés a modelos y estrategias listas para usar.'
  }, {
    title: 'Incorporás IA jurídica de manera profesional.',
    desc: 'Trabajás con más seguridad.'
  }, {
    title: 'Reducís errores.',
    desc: 'Mejorás la calidad de tus presentaciones.'
  }, {
    title: 'Captás más clientes.',
    desc: 'Organizás mejor tu estudio.'
  }, {
    title: 'Tomás casos con mayor confianza.',
    desc: 'Actuás con el respaldo de un sistema probado.'
  }];
  return <section className="py-12 bg-legal-800 border-y border-legal-700" data-id="element-36" data-mp="3csny23hey5s3">
      <div className="container mx-auto px-4" data-id="element-37" data-mp="1fzcgibjwmjdb">
        <div className="flex flex-col lg:flex-row items-center gap-12 max-w-6xl mx-auto" data-id="element-38" data-mp="1fz2okifau24z">
          <div className="flex-1" data-id="element-39" data-mp="1b1t3tg2uuenh">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-40" data-mp="1ayf30c9uadi5">
              Lo que cambia en tu práctica profesional
            </h2>
            <p className="text-lg text-slate-400 mb-8" data-id="element-41" data-mp="6tum2cxfreju">
              Este Megapack no es teoría vacía. Es una inversión directa en la
              eficiencia de tu estudio jurídico.
            </p>

            <div className="space-y-6" data-id="element-42" data-mp="3tyaeeji6qznd">
              {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: idx * 0.1
            }} className="flex gap-4" data-id="element-43" data-mp="liqo9tct9xcj" data-mpi={idx}>
                  <div className="mt-1" data-id="element-44" data-mp="19935xvxuz8gb">
                    <CheckCircle2 className="w-6 h-6 text-gold-500" data-id="element-45" data-mp="1j3ij0rq7f3p6" />
                  </div>
                  <div data-id="element-46" data-mp="1e3nngavhhpxs">
                    <h4 className="text-lg font-bold text-white mb-1" data-id="element-47" data-mp="1e5gxm05b2saj">
                      {benefit.title}
                    </h4>
                    <p className="text-slate-400" data-id="element-48" data-mp="1975ltjvga7po">{benefit.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex-1 w-full" data-id="element-49" data-mp="105640pcm2zlo">
            <div className="bg-legal-900 rounded-2xl p-8 border border-legal-700 shadow-2xl relative overflow-hidden" data-id="element-50" data-mp="hclgzojlfops">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold-500/10 blur-3xl rounded-full" data-id="element-51" data-mp="cflmmaw3waei"></div>
              <blockquote className="relative z-10" data-id="element-52" data-mp="2o1vri1r6zfeo">
                <p className="text-xl md:text-2xl font-serif text-slate-300 italic mb-6 leading-relaxed" data-id="element-53" data-mp="2t0guua1qqf7c">
                  "La diferencia entre un abogado que improvisa y uno que crece
                  de forma sostenida está en las herramientas que tiene
                  disponibles cada día."
                </p>
                <footer className="flex items-center gap-4" data-id="element-54" data-mp="25cyye17j6sy1">
                  <div className="w-12 h-1 bg-gold-500" data-id="element-55" data-mp="29cznqgw64ojv"></div>
                  <span className="text-gold-500 font-bold tracking-wide uppercase text-sm" data-id="element-56" data-mp="29b6h31lk24bv">
                    Tu tranquilidad profesional
                  </span>
                </footer>
              </blockquote>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};